import { render } from "./CustomerInfo.vue?vue&type=template&id=fa880d8c&scoped=true"
import script from "./CustomerInfo.vue?vue&type=script&lang=js"
export * from "./CustomerInfo.vue?vue&type=script&lang=js"

import "./CustomerInfo.vue?vue&type=style&index=0&id=fa880d8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa880d8c"]])

export default __exports__